/* This file is autogenerated, see readme.md for instructions */
import TabletLangscapeSvgIcon from '@bloomreach/banana-theme/icons/tablet-langscape.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TabletLangscapeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TabletLangscapeSvgIcon />
    </Icon>
  );
});

TabletLangscapeIcon.displayName = 'TabletLangscapeIcon';

export default TabletLangscapeIcon;
